import Vue from 'vue'
import VueRouter from 'vue-router'
import lanhu_vipfufei from '../views/vip/index.vue'
import lanhu_dengluweiyuyue from '../views/index/index.vue'
import lanhu_shouyekaoshi from '../views/exam/index.vue'
import lanhu_denglukaoshi from '../views/lanhu_denglukaoshi/index.vue'
import lanhu_shuatiyikaitong from '../views/lanhu_shuatiyikaitong/index.vue'
import lanhu_shuatiweikaitong from '../views/dash/index.vue'
import lanhu_denglukaoshi2 from '../views/lanhu_denglukaoshi2/index.vue'
import lanhu_denglushuati from '../views/lanhu_denglushuati/index.vue'
import lanhu_dengluyiyuyue from '../views/lanhu_dengluyiyuyue/index.vue'
import lanhu_denglu1 from '../views/login/index.vue'

import lanhu_dengludengdaijieguo from '../views/new/lanhu_dengludengdaijieguo'
import lanhu_denglugongsiruzhu from '../views/new/lanhu_denglugongsiruzhu'
import login2 from '../views/new/login2/index.vue'
import result from '../views/new/result/index.vue'


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: "/login"
    }

    ,
    {
        path: '/lanhu_dengludengdaijieguo',
        name: 'lanhu_dengludengdaijieguo',
        component: lanhu_dengludengdaijieguo
    }
    ,
    {
        path: '/login222',
        name: 'lanhu_denglugongsiruzhu',
        component: lanhu_denglugongsiruzhu
    },
    {
        path: '/login',
        name: 'login2',
        component: login2
    }

    ,
    {
        path: '/lanhu_dengluyiyuyue',
        name: 'lanhu_dengluyiyuyue',
        component: lanhu_dengluyiyuyue
    },
    {
        path: '/login12313',
        name: 'login',
        component: lanhu_denglu1
    },
    {
        path: '/vip',
        name: 'vip',
        component: lanhu_vipfufei
    },
    {
        path: '/index',
        name: 'index',
        component: lanhu_dengluweiyuyue
    },
    {
        path: '/exam/:type?',
        name: 'exam',
        component: lanhu_shouyekaoshi
    },
    {
        path: '/lanhu_denglukaoshi',
        name: 'lanhu_denglukaoshi',
        component: lanhu_denglukaoshi
    },
    {
        path: '/lanhu_shuatiyikaitong',
        name: 'lanhu_shuatiyikaitong',
        component: lanhu_shuatiyikaitong
    },
    {
        path: '/dash/:type?',
        name: 'dash',
        component: lanhu_shuatiweikaitong,
        props: true
    },
    {
        path: '/lanhu_denglukaoshi2',
        name: 'lanhu_denglukaoshi2',
        component: lanhu_denglukaoshi2
    },
    {
        path: '/lanhu_denglushuati',
        name: 'lanhu_denglushuati',
        component: lanhu_denglushuati
    },
    {
        path: '/result/:examId?/:recordId?',
        name: 'result',
        component: result,
        props: true
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
